<div [ngClass]="isOffline ? 'offline-header alert alert-warning' : 'hidden-offline-header'">
    <span>Not connected </span>
    <span> 
        <span style="--i:1">.</span>
        <span style="--i:2">.</span>
        <span style="--i:3">. </span>
    </span>
    <span>Please check your internet connection.</span>
</div>
<div [ngClass]="isOffline ? 'offline-overlay' : 'hidden-offline-overlay'"></div>
